import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import NumberInput from "./NumberInput";

type Story = ComponentStory<typeof NumberInput>;

const commonArgs: React.ComponentProps<typeof NumberInput> = {
    placeholder: "Placeholder",
    defaultValue: 7,
    disabled: false,
    helperText: "",
    label: "",
    leadingEnhancement: "",
    max: undefined,
    min: undefined,
    onChange: action("onChange"),
    trailingEnhancement: ""
};

export default {
    title: "Form Components/NumberInput",
    component: NumberInput,
    args: commonArgs
} as ComponentMeta<typeof NumberInput>;

const Template: Story = args => (
    <div style={{ width: "360px" }}>
        <NumberInput {...args} />
    </div>
);

export const Default = Template.bind({});

export const Placeholder = Template.bind({});
Placeholder.args = {
    defaultValue: undefined
};

export const Controlled: Story = args => {
    const [value, setValue] = React.useState<number | null>(7);

    return (
        <div style={{ width: "360px" }}>
            <NumberInput
                {...args}
                value={value}
                onChange={v => {
                    action("onChange")(v);
                    setValue(v);
                }}
            />
        </div>
    );
};
Controlled.args = {
    defaultValue: undefined,
    value: 10
};

export const WithoutStepButtons = Template.bind({});
WithoutStepButtons.args = {
    hideStepButtons: true
};

export const WithField = Template.bind({});
WithField.args = {
    label: "Leading label",
    helperText: "Helper text"
};

export const WithLeadingEnhancement = Template.bind({});
WithLeadingEnhancement.args = {
    leadingEnhancement: "Label"
};

export const WithTrailingEnhancement = Template.bind({});
WithTrailingEnhancement.args = {
    trailingEnhancement: "Label"
};

export const WithError = Template.bind({});
WithError.args = {
    error: (
        <>
            Available quantity of Product 1 at BER2: <strong>2000</strong>
        </>
    )
};

export const WithErrorAsString = Template.bind({});
WithErrorAsString.args = {
    error: "Available quantity of Product 1 at BER2: 2000"
};

export const WithErrorAsBoolean = Template.bind({});
WithErrorAsBoolean.args = {
    error: true
};
